import { observable } from 'rewire-core';
import { RowModel } from 'rewire-grid';
import DataMutations from '../graphql/Mutations';
import DataQueries from '../graphql/Queries';
import DocumentDialogModel from '../schedule/DocumentDialogModel';
import mainPageModel from '../main-navigation/MainPageModel';

const BatchSchema = `
  id
  code
  name
  tags
  status
  fields
`;

interface IBatchDetailsModel {
  batch?: RowModel;
}

const emptyFn: any = () => {};
export class BatchDetailsModel extends DocumentDialogModel {
  _state: IBatchDetailsModel;

  constructor() {
    super(
      'Batch',
      emptyFn, // load
      emptyFn, // insert
      emptyFn, // update
      emptyFn, // delete
      'batches',
      () => mainPageModel.canAddBatches,
      () => mainPageModel.canEditBatches,
      () => mainPageModel.canDeleteBatches,
    );

    this._state = observable({
      batch: undefined,
    });
  }

  private get batch(): RowModel | undefined {
    return this._state.batch;
  }

  private set batch(batch: RowModel | undefined) {
    this._state.batch = batch;
  }

  async setBatch(row?: RowModel) {
    this.batch = row;
    if (row?.data) {
      await super.load(row.data.id, false);
    }
  }

  loadUdfEditor = async () => {
    const udfEditor = super.udfEditor;
    if (udfEditor) {
      udfEditor.open();
    }
    return false;
  };

  mapToSave(): ObjectType {
    const obj = super.mapToSave();
    delete obj.status;
    return obj;
  }

  addBatch = async () => {
    this.setBatch(undefined);
    await super.load(undefined, false);
  };

  deleteBatch = async (): Promise<unknown> => {
    const value = await super.remove();
    return value;
  };

  async submit() {
    await super.submit();
    if (this.batch && !this.error) {
      this.batch.data.name = this.form.field.name.value;
    }
    return false;
  }
}

const batchDetailsModel = new BatchDetailsModel();
export default batchDetailsModel;
